import * as React from 'react';
import { ADMIN, CDS, IN_PROGRESS, MEDIA_UPLOAD, PROFILE, PUBLISHED } from '../../../constants/status';
import { SUBMITTED_FOR_REVIEW, triggerModal } from '../ModulePage/exportfiles';
import { ModalComponent } from '../ModulePage/exportfiles';
import { ToolTip } from '../../../components';
import {ADMIN_ROLE, EM_ROLE} from "../../../constants/global";
import {Context} from '../../../context/dataStore';
import { FeatureFlags } from '../../../services/featureflag/featureflags';
import { adminView, cdsView, profileView, bgColors } from '../../../constants/welcome';

const SideBar = ({ categoryData, navSelection, setNavSelection, setCategoryName,
  setCategoryStatus, pageDirty, selApiAttribute, setSelApiAttribute, disable, roles}) => {

  const [toSelection, setToSelection] = React.useState();
  const [toApiAttr, setToApiAttr] = React.useState();
  const [toCategoryName, setToCategoryName] = React.useState();
  const [toIndicator, setToIndicator] = React.useState();
  const {state: {featureFlagStatus}} = React.useContext(Context);
  const lockdiv = (id, locked) => {
    if(locked){
      return (<div>
              <ToolTip tooltipid={'tip_l_'+id} tooltipMsg={'LOCKED'} innerMsg={''} className={'cb-icon cb-lock'} />
              </div>);
    }
    return (<></>);
  };
  
  const statusIndicator = (status, id, locked) => {
      switch (status.toUpperCase()) {
        case SUBMITTED_FOR_REVIEW:
          return (<div style={{float:'right', padding:'10px 0px', display:'flex'}}>{lockdiv(id, locked)}<ToolTip tooltipid={'tip_s_'+id} tooltipMsg={'SUBMITTED'} innerMsg={''} className={'cb-icon cb-disc-alt cb-blue5-color'} /></div>);
        case IN_PROGRESS:
          return (<div style={{float:'right', padding:'10px 0px', display:'flex'}}>{lockdiv(id, locked)}<ToolTip tooltipid={'tip_i_'+id} tooltipMsg={'IN PROGRESS'} innerMsg={''} className={'cb-icon cb-circle cb-blue5-color'} /></div>);
        case PUBLISHED:
          return (<div style={{float:'right', padding:'10px 0px', display:'flex'}}>{lockdiv(id, locked)}<ToolTip tooltipid={'tip_p_'+id} tooltipMsg={'ACCEPTED'} innerMsg={''} className={'cb-icon cb-check-fill cb-blue5-color'} /></div>);
        default:
          return (<div style={{float:'right', padding:'10px 0px', display:'flex'}}>{lockdiv(id, locked)}<ToolTip tooltipid={'tip_i_'+id} tooltipMsg={'READY TO EDIT'} innerMsg={''} className={'cb-icon cb-circle cb-blue5-color'} /></div>);
      }
    
  };

  const changeSelection = (tobeSelected, toapiAttr, categoryName, indicator) => {
    setNavSelection(tobeSelected);
    setSelApiAttribute(toapiAttr);
    setCategoryName(categoryName);
    if (indicator) {
      setCategoryStatus(() => indicator);
    }
  };

  const onCheck = (tobeSelected, toapiAttr, categoryName, indicator) => {
    if (selApiAttribute === 'apcpCreditPolicyCategory' && pageDirty === 'Y') {
      setToSelection(tobeSelected);
      setToApiAttr(toapiAttr);
      setToCategoryName(categoryName);
      setToIndicator(indicator);
      triggerModal('confirmdialog');
    }
    else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      changeSelection(tobeSelected, toapiAttr, categoryName, indicator);
    }
  };

  const handleRedirect = ()=>{
    changeSelection(toSelection, toApiAttr, toCategoryName, toIndicator);
  };

  return (
    <div className={disable?'cb-box disableClick':'cb-box'} style={{ flex: '10%' }}>
      {<ModalComponent modalId='confirmdialog' bodycontent={[]} handleRedirect={handleRedirect}/> }
      <nav className="cb-menu-list cb-menu-list-vertical" aria-label="Institution Categories"
        style={{ backgroundColor: bgColors.Grey }} id='sideBarNav'>
        <ul>
          <li className={navSelection ==='welcome' ? 'itemSelected' : 'specialItem'}>
            <a href='true' className='cb-menu-link category-link'
              onClick={(event) => { event.preventDefault(); onCheck('welcome', 'welcome', 'welcome'); }}>
              <span className='menuLabel' style={navSelection ==='welcome' ? { color: 'white' } : {}}>Welcome </span>
            </a>
          </li>
          {roles[0] === ADMIN_ROLE && (
            <li className={navSelection === ADMIN ? 'itemSelected' : 'specialItem'}>
              <a
                href='true'
                className='cb-menu-link category-link'
                onClick={event => {
                  event.preventDefault();
                  onCheck(ADMIN, ADMIN, 'Admin Overview');
                }}>
                <span className='menuLabel' style={navSelection === ADMIN ? {color: 'white'} : {}}>
                  {adminView}
                </span>
              </a>
            </li>
          )}

          {/* Undo Media upload */}
          {/* {(featureFlagStatus[FeatureFlags.mediauploadpage]) && <li className={navSelection === MEDIA_UPLOAD ? 'itemSelected' : 'specialItem'}>
            <a href="true" className="cb-menu-link"
              onClick={(event) => { event.preventDefault(); onCheck(MEDIA_UPLOAD, MEDIA_UPLOAD, 'Upload Media'); }}>
              <span className='menuLabel' style={navSelection === MEDIA_UPLOAD ? { color: 'white' } : {}}> Upload Media </span>
            </a>
          </li>} */}
          <>
          {roles[0]!==EM_ROLE ? 
            <>
              <li className={navSelection === CDS ? 'itemSelected' : 'specialItem'}>
                <a href="true" className='cb-menu-link category-link'
                  onClick={(event) => { event.preventDefault(); onCheck(CDS, CDS, CDS); }}>
                  <span className='menuLabel' style={navSelection === CDS ? { color: 'white' } : {}}> {cdsView} </span>
                </a>
              </li> 
            </> : 
            <></>
          }

          {categoryData?.map(e => {
            if(e.api_attribute!='adminCategory'){
              if(e.api_attribute&&e.api_attribute!=='degreeOfferingsCategory')
              {
                let prefix = '';

                if(e.is_locked){
                  prefix = 'tip_l_';
                }
                else{
                  if(e.status.toUpperCase()===SUBMITTED_FOR_REVIEW){
                    prefix = 'tip_s_';
                  }

                  if(e.status.toUpperCase()===IN_PROGRESS){
                      prefix = 'tip_i_';
                  }
                  
                  if(e.status.toUpperCase()===PUBLISHED){
                    prefix='tip_p_';
                  }
                }
                const describe = 'cat-'+e.id+' '+prefix+e.id;
                return (
                  <li key={e.id} className={navSelection === e.id ? 'itemSelected' : ''}>
                    <a href="true" className='cb-menu-link category-link' aria-labelledby={describe}
                      onClick={(event) => {
                        event.preventDefault();
                        onCheck(e.id, e.api_attribute, e.category_name, e.status.toUpperCase());
                      }}>
                      <span key={'ind-' + e.id} id={'cat-'+e.id} className='menuLabel' 
                      style={navSelection === e.id ? { color: 'white' } : {}}> {e.title} </span>
                      {statusIndicator(e.status, e.id, e.is_locked)}
                      </a>
                    
                  </li>);
              }
              else {
                return (<li key={e.id}></li>);
              }
            }
          })}
          </>
        </ul>
      </nav>

    </div>
  )

};

export default SideBar;